import { render, staticRenderFns } from "./admin_check.vue?vue&type=template&id=3f251e10&scoped=true&"
import script from "./admin_check.vue?vue&type=script&lang=js&"
export * from "./admin_check.vue?vue&type=script&lang=js&"
import style0 from "./admin_check.vue?vue&type=style&index=0&id=3f251e10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f251e10",
  null
  
)

export default component.exports